import React from 'react'
import { ToastContainer as ReduxToastContainer } from 'react-toastify-redux'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import successToastrImage from 'assets/img/icons/icon-check.png'
import errorToastrImage from 'assets/img/icons/icon-warning.png'

export const ToastContainer = () => {
  const documentBaseFontSize = ds.get('type.baseFontSize')

  return (
    <div
      style={{
        // @ts-ignore
        '--backgroundColor': ds.brand('white'),
        '--color': ds.get('colors.texts.default'),
        '--fontWeight': 'bold',
        '--fontSize': pxTo(14, documentBaseFontSize, 'rem'),
        '--lineHeight': pxTo(20, documentBaseFontSize, 'rem'),
        '--boxShadow': '0 2px 5px 0 rgba(0,0,0,0.2);',
        '--borderRadius': pxTo(3, documentBaseFontSize, 'rem'),
        '--progressBackground': ds.brand('gradient'),
        '--progressErrorBackground': ds.brand('brightOrange'),
        '--progressHeight': pxTo(5, documentBaseFontSize, 'rem'),
        '--progressBorderRadius': pxTo(3, documentBaseFontSize, 'rem'),
        '--closeColor': ds.brand('grey'),
        '--spacing': pxTo(15, documentBaseFontSize, 'rem'),
        '--withBackgroundLeftSpacing': pxTo(55, documentBaseFontSize, 'rem'),
        '--errorBackgroundImage': `url("${errorToastrImage}")`,
        '--successBackgroundImage': `url("${successToastrImage}")`,
      }}
    >
      <ReduxToastContainer autoClose={10000} />
    </div>
  )
}
